import {
  Gavel,
  Reply,
  Scale,
  Receipt,
  Archive,
  MessageCircleQuestion,
  Folder,
  MessageSquare,
  BarChart3,
  FileText,
  Upload,
  Plus,
  Check,
  CheckCircle2,
  Send,
  Search,
  X,
  Clock,
  LogOut,
  CornerUpLeft,
  Pencil,
  ChevronDown,
  ChevronRight,
  ArrowRight,
  ExternalLink,
  Shield,
  Dot,
  Sparkles,
  BookOpen,
  Home,
  Menu,
  PanelLeft,
  SlidersHorizontal,
  Download,
  Eye,
  Trash2,
  TriangleAlert,
  RotateCcw,
  Share2,
  Users,
  Flag,
  FileType2,
  Paperclip,
  Loader2,
  type LucideIcon,
} from "lucide-react"

/**
 * Maps the design handoff's icon names (na-icons.jsx) to lucide-react icons,
 * so component markup stays 1:1 with the design source.
 */
const ICONS: Record<string, LucideIcon> = {
  paperclip: Paperclip,
  loader: Loader2,
  gavel: Gavel,
  reply: Reply,
  scale: Scale,
  receipt: Receipt,
  vault: Archive,
  archive: Archive,
  qa: MessageCircleQuestion,
  folder: Folder,
  message: MessageSquare,
  chart: BarChart3,
  file: FileText,
  upload: Upload,
  plus: Plus,
  check: Check,
  checkc: CheckCircle2,
  send: Send,
  search: Search,
  x: X,
  clock: Clock,
  logout: LogOut,
  sendback: CornerUpLeft,
  edit: Pencil,
  chevdown: ChevronDown,
  chevright: ChevronRight,
  arrowr: ArrowRight,
  ext: ExternalLink,
  shield: Shield,
  dot: Dot,
  sparkle: Sparkles,
  book: BookOpen,
  home: Home,
  menu: Menu,
  panelleft: PanelLeft,
  filter: SlidersHorizontal,
  download: Download,
  eye: Eye,
  trash: Trash2,
  alert: TriangleAlert,
  retry: RotateCcw,
  share: Share2,
  users: Users,
  flag: Flag,
  filetype: FileType2,
}

export interface IconProps {
  name: string
  size?: number
  className?: string
  strokeWidth?: number
}

export function Icon({ name, size = 17, className = "", strokeWidth = 1.6 }: IconProps) {
  const Cmp = ICONS[name]
  if (!Cmp) return null
  return <Cmp className={`ico ${className}`.trim()} size={size} strokeWidth={strokeWidth} />
}
